module.exports = __webpack_public_path__ + "static/media/KostaBodaLogo.b1a1b84a.svg";